import React from "react";
import "./styles.scss";
import { Spinner } from "react-bootstrap";
import HvProgress from "../../HvProgress";

export default () => {
  return (
    <div className="post_place_holder audio-tag d-flex align-items-center">
      <div className="preview-img">
        <img className="default" alt="" />
      </div>
      <div className="controls d-flex px-3 align-items-center">
        <Spinner
          animation="border"
          variant="danger"
          size="sm"
          role="status"
          style={{ minWidth: "1rem", minHeight: "1rem" }}
        />
        <HvProgress className="w-100" showTimeUnderBar />
      </div>
      <div className=" title">
        <p className="text"></p>
      </div>
    </div>
  );
};
